import React from 'react';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './DownloadFileBtn.module.scss';

interface IDownloadFileBtn {
	generatedWatchCommandsLink: Nullable<string>;
}

const DownloadFileBtn: React.FC<IDownloadFileBtn> = ({ generatedWatchCommandsLink }) => {
	return (
		<div className={style.container} data-test="DownloadFileBtn">
			<BlobDownloader
				filePath={generatedWatchCommandsLink}
				fileExtension="zip"
				fileName="watches"
				label="downloadFile"
			/>
		</div>
	);
};

export default React.memo(DownloadFileBtn);
